import React from "react";
import { Outlet } from "react-router-dom";
function Layout() {
  return (
    <div className="flex h-screen w-screen overflow-hidden overflow-x-hidden">
      <Outlet />
    </div>
  );
}

export default Layout;
